export default __webpack_public_path__ + "static/media/ic-logo.048cc29d.svg";